<template>
  <div class="container-fluid mt-4">
    <vx-card title="Búsqueda de información de inversionista">
      <div class="input">
        <vs-input
          type="number"
          class="w-full"
          icon-pack="feather"
          icon="icon-user"
          placeholder="Id de Inversionista"
          @keyup.enter="findData()"
          v-model="investorId"/>
      </div>


      <div class="result">
        <table>
          <thead>
            <th class="text-left">IID</th>
            <th>Inversión efectiva</th>
            <th>Amortización del periodo</th>
            <th>Intereses + Moratorios + Penalizaciones</th>
            <th>PID</th>
            <th>Project status</th>
            <th>Credit status</th>
            <th>Inversión efectiva</th>
            <th>Factura (total cost)</th>
            <th>Fecha fondeo</th>
            <th>Fecha anticipo</th>
            <th>Fecha finiquito</th>
            <th>Meses pagados</th>
            <th>Plazo</th>
            <th>Meses no pagados</th>
            <th>Calificación</th>
            <th>Tasa de interés anual</th>
          </thead>
          <tbody>
            <tr v-for="project in investorData.projects">
              <td>{{investorData.investor_id}}</td>
              <td>{{investorData.fixed_investment}}</td>
              <td>{{investorData.amortization_period}}</td>
              <td>{{investorData.interest_moratorium_penalties}}</td>
              <td>{{project.id}}</td>
              <td>{{project.project_status}}</td>
              <td>{{project.credit_status}}</td>
              <td>{{project.fixed_investment}}</td>
              <td>{{project.invoice}}</td>
              <td>{{project.fund_date|_humanizeDate}}</td>
              <td>{{project.first_payment_date|_humanizeDate}}</td>
              <td>{{project.second_payment_date|_humanizeDate}}</td>
              <td>{{project.paid_months}}</td>
              <td>{{project.term}}</td>
              <td>{{project.unpaid_months}}</td>
              <td>{{project.qualification}}</td>
              <td>{{project.annual_interest_percentage}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vx-card>
  </div>
</template>

<script>

import {_humanizeDate} from "@/filters/momentTzConvert";

export default {
  name: "InvestorAnalysisReport",
  data: () => ({
    investorData: {},
    investorId: null
  }),
  filters: {
    _humanizeDate,
  },
  methods: {
    async findData() {
      let investor_id = this.investorId;
      try {
        const {data} = await axios.post(`/api/reports/investor-analysis`, {
          investor_id
        })
        this.investorData = data;
      } catch (e) {
        if(e.response.status === 400) {
          await swal("Error", e.response.data.message, 'error');
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
